import React from 'react';
import { Box } from '@mui/material';

import theme from 'config/theme';

const stageChipStyles = {
  wrapper: {
    fontWeight: 500,
    fontSize: '0.875rem',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 8px',
    height: '25px',
    lineHeight: '25px',
    color: theme.palette.blues.babyBlue900,
    width: 'fit-content',
  },
};

const StageChip = ({ children, styles = {}, icon }) => {
  return (
    <Box
      sx={{
        ...stageChipStyles.wrapper,
        ...styles,
      }}
    >
      {icon?.()}
      {children}
    </Box>
  );
};

export default StageChip;
